window.addEventListener("hoContentLoaded", () => {
	Vue.component('reveal', {
		data: function () {
			return {
				active: false,
				initialPosition: 0
			}
		},
		props: {
			margin: {
				type: Number,
				default: 0
			},
			mobileMargin: {
				type: Number,
				default: 0
			},
			scrollTopAfterClose: {
				type: Boolean,
				default: false
			},
			scrollToRevealPositionAfterClose: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			toggle() {
				if(!this.active) {
					// Speichere die aktuelle Scroll-Position beim Öffnen
					if (this.scrollToRevealPositionAfterClose) {
						this.initialPosition = window.scrollY;
					}
					this.active = true;
				}
				else {
					const controls = this.$el.querySelector(".content-reveal-controls");
					let offset = 0;

					if(controls)
						offset = controls.getBoundingClientRect().height;

					let m = 0;
					if(window.innerWidth < 768)
						m = this.mobileMargin;
					else
						m = this.margin;

					// Scroll-Verhalten basierend auf den Optionen
					if (this.scrollTopAfterClose) {
						window.providerScroll.scrollTo(this.$el,offset+m);
					} else if (this.scrollToRevealPositionAfterClose) {
						window.providerScroll.scrollToValue(this.initialPosition, 0);
					}

					this.active = false;
				}
			}
		}
	});
});
